import { render, staticRenderFns } from "./iconPinterest.vue?vue&type=template&id=04f3986b&scoped=true"
import script from "./iconPinterest.vue?vue&type=script&lang=js"
export * from "./iconPinterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f3986b",
  null
  
)

export default component.exports